import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { NCashAllocationComponent } from '../../nCash-allocation/nCash-allocation.component';
import { ViewSwiftAllocationComponent } from '../../view-swift-allocation/view-swift-allocation.component';

@Component({
  selector: 'app-invest-perference',
  templateUrl: './invest-perference.component.html',
  styleUrls: ['./invest-perference.component.css']
})
export class InvestPerferenceComponent implements OnInit {

  private readonly matDialog: MatDialog;

  @Input() preferenceValue;
  @Input() productDataForNCash;
  @Input() productDataForSwift;

  constructor(
    matDialog: MatDialog,
  ) {
    this.matDialog = matDialog;
   }

  ngOnInit(): void {
  }

  public onViewPopup(popUpName: string):  void {
    const matDialogConfig: MatDialogConfig = {
      height: '90%',
      width: '800px',
      maxWidth: '1000px',
      maxHeight: (popUpName == 'nCash') ? '424px' : '508px',
      panelClass: (popUpName == 'nCash') ? 'view-popup-responsive' : 'view-popup-swift',
      data: (popUpName == 'nCash') ? {
        productData: this.productDataForNCash,
      } : {
        productData: this.productDataForSwift,
      }
    };
    if (popUpName == 'nCash') {
      this.matDialog.open(NCashAllocationComponent, matDialogConfig);
    } else {
      this.matDialog.open(ViewSwiftAllocationComponent, matDialogConfig);
    }
  }
}
